<template>
  <section class="app-wrapper">
    <app-header />
    <div class="app-wrapper-body">
      <keep-alive include="HomePage,KnowConsult,UnitConsult">
        <router-view />
      </keep-alive>
      <div class="advert1" v-if="isLook.left" :style="adverStyle">
        <img class="adver-img" src="@/assets/home/left.png" alt="" @click="linkTo('left')" />
        <div class="close">
          <button class="close-btn" @click="showadvert('left')">关闭</button>
        </div>
      </div>
      <div class="advert2" v-if="isLook.right" :style="adverStyle">
        <img class="adver-img" src="@/assets/home/right.png" alt="" @click="linkTo('right')" />
        <div class="close">
          <button class="close-btn" @click="showadvert('right')">关闭</button>
        </div>
      </div>
    </div>
    <div class="app-wrapper-footer">
      <app-footer />
    </div>
  </section>
</template>
<script>
import AppFooter from './AppFooterView.vue'
import AppHeader from './AppHeader.vue'
export default {
  components: { AppHeader, AppFooter },
  data() {
    return {
      isLook: {
        left: true,
        right: true
      },
      adverStyle: {}
    }
  },
  mounted() {
    window.onscroll = () => {
      const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      if (scrollTop > 400) {
        this.adverStyle = { top: scrollTop - 300 + 'px' }
      } else {
        this.adverStyle = { top: 50 + 'px' }
      }
    }
  },
  methods: {
    showadvert(type) {
      this.isLook[type] = false
    },
    linkTo(type) {
      const url = {
        left: '',
        right: ''
      }
      this.$router.push(url[type])
    }
  }
}
</script>
<style lang="less" scoped>
  .app-wrapper-footer {
    width: 100%;
    height: 300px;
    background: #c03429;
  }
  .advert1 {
    width: 100px;
    height: 273px;
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    .adver-img {
      width: 100%;
      // height: 402px;
    }
    .close {
      text-align: right;
      .close-btn {
        font-size: 16px;
        color: #999999;
        background: none;
      }
    }
  }
  .advert2 {
    width: 100px;
    height: 273px;
    position: absolute;
    z-index: 99;
    top: 0;
    right: 0;
    .adver-img {
      width: 100%;
      // height: 402px;
    }
    .close {
      text-align: right;
      .close-btn {
        font-size: 16px;
        color: #999999;
        background: none;
      }
    }
  }  
</style>